import { DateRangeType } from "react-tailwindcss-datepicker";

import CustomDatePicker from "../../awaitingInventory/CustomDatePicker";
import { IDashboardStats } from "../../../models/DashboardStats";
import { ActivityMetricKey } from "./activityMetrics";
import ActivityTable from "./ActivityTable";

interface IPerformanceUserActivityTableProps {
  title: string;
  rowLabelColumn: string;
  stats?: IDashboardStats;
  daysInPeriod: number;
  isLoading?: boolean;
  dates: DateRangeType;
  onDatesChange: (dates: DateRangeType) => void;
  selectedMetric?: ActivityMetricKey;
  onMetricSelect?: (key: ActivityMetricKey) => void;
}

export default function PerformanceUserActivityTable({
  title,
  rowLabelColumn,
  stats,
  daysInPeriod,
  isLoading = false,
  dates,
  onDatesChange,
  selectedMetric,
  onMetricSelect,
}: IPerformanceUserActivityTableProps) {
  return (
    <ActivityTable
      title={title}
      rowLabelColumn={rowLabelColumn}
      activityByUser={stats?.userActivity}
      activityTotal={stats?.userActivityTotal}
      daysInPeriod={daysInPeriod}
      isLoading={isLoading}
      selectedMetric={selectedMetric}
      onMetricSelect={onMetricSelect}
      headerControls={
        <CustomDatePicker
          dates={dates}
          handleDatesChange={onDatesChange}
          inputClassName="h-10 text-sm border-gray-300 rounded-md focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 w-64"
        />
      }
    />
  );
}
